"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrevStep = exports.getNextStep = exports.getActiveStep = exports.getActiveStepState = void 0;

var _reselect = require("reselect");

var _ramda = require("ramda");

var _activeStep = require("./activeStep.reducer");

var _activeStep2 = require("./activeStep.constants");

var getActiveStepState = function getActiveStepState(state) {
  return state.modules.giftingFlow.ui[_activeStep.name];
};

exports.getActiveStepState = getActiveStepState;
var getActiveStep = (0, _ramda.pipe)(getActiveStepState, (0, _ramda.prop)('step'));
exports.getActiveStep = getActiveStep;
var getNextStep = (0, _reselect.createSelector)(getActiveStep, function (step) {
  return _activeStep2.STEPS_ORDER[Math.min((step ? _activeStep2.STEPS_ORDER.indexOf(step) : 0) + 1, _activeStep2.STEPS_ORDER.length - 1)];
});
exports.getNextStep = getNextStep;
var getPrevStep = (0, _reselect.createSelector)(getActiveStep, function (step) {
  return _activeStep2.STEPS_ORDER[Math.max(0, (step ? _activeStep2.STEPS_ORDER.indexOf(step) : 0) - 1)];
});
exports.getPrevStep = getPrevStep;